import storageService from '../../services/storage-service';
import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';

export interface Props extends DialogProps {
  _id: string;
}

export default class ExportStatusDialog extends DialogComponent<Props> {

  state = {
    collections: [],
    exportedCount: 0,
    exportFinished: false,
    error: ''
  };

  interval = null;

  render() {
    const { exportedCount, collections } = this.state;
    let percent = exportedCount * 100 / collections.length;
    if (Number.isNaN(percent)) {
      percent = 0;
    }
    return (
      <>
        <div className="text-center mb-3" style={{ fontSize: '0.95rem' }}>
          {exportedCount} مورد از {collections.length} انجام شده
        </div>
        <div className="progress" style={{ height: '1.9rem' }}>
          <div
            style={{ width: percent + '%', fontWeight: 500, fontSize: '0.9rem' }}
            className="progress-bar bg-success">
            {percent}%
          </div>
        </div>
      </>
    );
  }

  componentDidMount = () => {
    this.interval = setInterval(async () => {
      try {
        const res = await storageService.getExportStatus(this.props._id);
        if (res.exportFinished || res.error != null) {
          clearInterval(this.interval);
          if (res.error == null) {
            setTimeout(() => {
              this.close(true);
            }, 1000);
          }
        }
        this.setState(res);
      }
      catch (e) {
        this.setState({ error: e.message });
        clearInterval(this.interval);
      }
    }, 500);
  }

  componentWillUnmount = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

}
